// extracted by css-extract-rspack-plugin
var _1 = "column-name-A8EjKU";
var _2 = "column-name-A8EjKU";
var _3 = "filter-cnJL8N";
var _4 = "table-ZQuewj";
export { _1 as "column-name", _2 as "columnName", _3 as "filter", _4 as "table" }
